module.exports = __webpack_public_path__ + "img/mobil.98df8a57.svg";